import { gql } from 'graphql-tag'
import { fragmentGlobalDataLanguage } from '../../../../core/data-layer/global-data/fragments'
import { fragmentModuleNavigationLink } from '../../../../core/data-layer/modules/fragments'

export default gql`
  ${fragmentGlobalDataLanguage}
  ${fragmentModuleNavigationLink}
  fragment BlockPartnerMetadataFragment on BlockPartnerMetadata {
      partnerName
      location {
        sys {
          id
        }
        name
        internalName
      }
      languagesCollection {
        items {
          ...GlobalDataLanguageFragment
        }
      }
      url
      availabilityCollection {
        items {
          sys {
            id
          }
          name
          internalName
        }
      }
      industriesCollection {
        items {
          sys {
            id
          }
          contentType: __typename
          name
          link {
            ...ModuleNavigationLinkFragment
          }
        }
      }
      productsCollection {
        items {
          sys {
            id
          }
          contentType: __typename
          name
          link {
            ...ModuleNavigationLinkFragment
          }
        }
      }
      partnersCollection {
        items {
          sys {
            id
          }
          name: partnerName
        }
      }
      paymentMethodsCollection {
        items {
          sys {
            id
          }
          paymentMethod {
            name
          }
        }
      }
      terminalsCollection {
        items {
          sys {
            id
          }
          name: terminalName
        }
      }
  }
`
